<template>

<!--
        0 -> # computer ancora senza licenza one, ma in rubrica di Iperius Remote
        1 -> # computer connesso tuttora alla licenza corretta;
        2 -> # computer in stato di waiting solo con questa licenza: si può ricollegare;
        3 -> # computer rimosso da questa licenza: NON si potrà ricollegare fino a riabilitazione;
        4 -> # computer BANNATO: non si potrà mai più ricollegare fino a nostro contrordine;

        $root.noIperiusOneLicense

-->

    <div>
        <a class="button secondary" :title="computer.backup_license_status == 2 ? $t('Waiting to restart agent') : ''"
            :class="computer.backup_license_status == 2 ? 'fg-white bg-amazon' : computer.backup_license_status == 3 ? 'fg-white bg-secondary dropdown-toggle' :  ' dropdown-toggle'">
        <!--<a class="button secondary" :title="computer.backup_license_status == 2 ? $t('Waiting to restart agent') : ''"
            :class="computer.backup_license_status == 1 ? 'fg-white bg-green dropdown-toggle' : computer.backup_license_status == 2 ? 'fg-white bg-orange' : 'fg-white bg-red dropdown-toggle'">
        -->
            <div class="text-left">
                <span class="mif-admin_panel_settings mif-3x"></span>
            </div>
        </a>
        <ul class="d-menu border place-right text-center" data-role="dropdown">

            <li v-if="computer.backup_license_status != 1" class="bd-gray border-bottom">
                <a class="text-bold">
                    {{ $t(computer.notConnectedDefaultMessage) }}
                </a>
            </li>

            <li v-if="computer.backup_license_status == 0" class="text-center p-4">
                <span class="mif-lock fg-red mif-2x mb-2"></span>
                <span class="d-block">
                    {{ $t("Iperius One is not available on this device. Iperius One allows you to monitor a computer's status, manage backup and restore, handle updates, policies, and much more.") }}
                </span>                    
                <router-link class="ml-1 text-bold" :to="'/licenses'" style="cursor:pointer;">
                    {{ $t("Get your Iperius One license to activate this feature") }}
                </router-link>
            </li>
            <template v-else>
                <li>
                    <a class="text-left" :data-tip="$t('Removing the device from the license frees the slot; the agent on the computer is stopped and related services are stopped and disabled.')" @click.prevent="removeFromLicense(computer.id)"
                        :class="computer.backup_license_status == 1 ? '' : 'fg-gray disabled'">
                        <img src="/assets/img/icons/rem-device.svg"></img>{{ $t("Remove from license") }}
                    </a>
                </li>
                <li>
                    <a class="text-left" :data-tip="$t('Adding the device to the license re-enables the slot; you must manually start IperiusOne services from the Windows Services console.')" @click.prevent="reconnectToLicense(computer.id)"
                        :class="computer.backup_license_status == 3 ? '' : 'fg-gray disabled'">
                        <!--span class="icon mif-2x mif-link-on"></span> {{ $t('Add to license') }} -->
                        <img src="/assets/img/icons/add-device.svg"></img>{{ $t("Add to license") }}
                    </a>
                </li>
            </template>
        </ul>
        
    </div>
</template>
<script>
import { PC_MESSAGES } from '../../utils/messages.js';
export default {
    name: "PCLicenseLink",
    props: {
        computer: {
            type: Object,
            required: true
        },
        parentName: String,
    },
    methods: {
        async removeFromLicense(idPC) {
            var dialogID=Math.floor(100000+Math.random()*900000).toString();
            let self=this;
            this.$root.$on(dialogID, ok => {
                self.$root.$off(dialogID);

                if (!ok) {
                    return;
                }

                this.$api.removeFromLicense(idPC).then(async (value) => {
                    if (value) {
                        self.$root.toast(this.$t(PC_MESSAGES.LICENSE_REMOVED), "success");
                        self.computer.backup_license_status=3;
                        let ext_lic_info=await self.$api.getLicenseExtendedInfo();

                        if (ext_lic_info!=null) {
                            this.$session.setLicenses(ext_lic_info);
                            //this.licenses = this.$session.get("LICENSES");
                            this.updateLicenseInLicenseVue();
                        };
                    }

                });
            });
            this.$root.openYesNoDialog(dialogID, this.$t("Remove device from license"), this.$t("Are you sure to remove this device from license?"));
        },

        async reconnectToLicense(idPC) {
            var dialogID=Math.floor(100000+Math.random()*900000).toString();
            let self=this;
            this.$root.$on(dialogID, ok => {
                self.$root.$off(dialogID);

                if (!ok) {
                    return;
                }

                self.$api.addToLicense(idPC).then(async (value) => {
                    if (value) {
                        self.$root.toast(this.$t(PC_MESSAGES.LICENSE_ADDED), "success")
                        self.computer.backup_license_status=2;

                        let ext_lic_info=await self.$api.getLicenseExtendedInfo();

                        if (ext_lic_info!=null) {
                            this.$session.setLicenses(ext_lic_info);
                            //this.licenses = this.$session.get("LICENSES");
                            this.updateLicenseInLicenseVue();
                        };

                    }
                });
            });

            this.$root.openYesNoDialog(dialogID, this.$t("Register device to license"), this.$t("Are you sure to register this device to license?"));
        },

        updateLicenseInLicenseVue() {
            if (this.parentName==='Licenses')
                this.$emit('updateLicense');
        }

    }


}
</script>